// extracted by mini-css-extract-plugin
export default {"ticker":"RunningLine_ticker__ABicl","track":"RunningLine_track__2klv5","set":"RunningLine_set__bYyVl","text":"RunningLine_text__GGEhK","separator":"RunningLine_separator__YEexM"};